// @flow
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { DEFAULT_COUNTRIES, getLocalizedCountry } from '../../local-values/utils/countries';
import { domainRedirectMap } from '../../../server/middleware/redirect'
import queryString from 'query-string';
import { getChosenVariant } from '../../ab-test/utils';

import style from './Footer.scss';
import greyLogo from '../../../assets/img/Logo-grey-qempo.png';
import icons from '../../../assets/styles/icons.scss';

import type { User } from '../../../entities';
import type { ProfileData } from '../../preferences/edit-profile/duck';
import type { LocaleState } from '../../locale/duck';
import type { Location } from '../../../router';
import type { LocalValuesState } from '../../local-values/duck';
import type { LocalValueCountry } from '../../local-values/utils/countries';

type Props = {
  +localeState: LocaleState;
  +changeLocale: (locale: string) => void;
  +authenticated?: boolean;
  +user?: User;
  +editProfile: (profileData: ProfileData) => void;
  +location: Location;
  +localValues: LocalValuesState;
  +chosenVariants?: { [key: string]: number };
};

type State = {
  infoOpen: boolean;
  resOpen: boolean;
  serOpen: boolean;
  conOpen: boolean;
  isBrowser: boolean;
};

export default class Footer extends Component<Props, State> {
  state = {
    infoOpen: false,
    resOpen: false,
    serOpen: false,
    conOpen: false,
    isBrowser: false,
  };

  componentDidMount() {
    this.setState({
      isBrowser: true,
    });
  }

  handleChangeCountry = (e: Event) => {
    const { user, location } = this.props;
    if (e.target instanceof HTMLSelectElement) {
      const { value } = e.target;
      const locationSearch = queryString.parse(location.search);
      if (value === 'US') {
        locationSearch.noredirect = true;
      }
      let locationSearchString = queryString.stringify(locationSearch);
      locationSearchString = locationSearchString ? `?${locationSearchString}` : '';
      window.location.href = `${domainRedirectMap[value]}${location.pathname}${locationSearchString}`;
    }
  };

  handleChangeLocale = (e: Event) => {
    const { user } = this.props;
    if (e.target instanceof HTMLSelectElement) {
      const { value } = e.target;
      const { changeLocale, editProfile } = this.props;
      changeLocale(value);
      if (user) {
        editProfile({
          languageCode: value.toUpperCase(),
        });
      }
    }
  };

  handleClick(e: Event) {
    if (e.target instanceof HTMLButtonElement) {
      const { name } = e.target;
      this.setState((state: State) => ({ [name]: !state[name] }));
    }
  }

  render() {
    const { localeState, localValues, location, chosenVariants } = this.props;
    const { infoOpen, resOpen, serOpen, conOpen, isBrowser } = this.state;

    const countryOptions = (localValues.countries || DEFAULT_COUNTRIES).map((country: LocalValueCountry, n: number) =>
      <option key={n}
              value={country.key}>{
        getLocalizedCountry(country.key, this.context.intl.formatMessage, localValues.countriesMap)
      }</option>);

    const isTiendas = location.pathname.split('/')[1] === 'tiendas';

    const countryIcon = localValues.countriesMap &&
      localValues.countriesMap[localeState.domainCountry || ('US': string)].icon;
    const chosenVariant = getChosenVariant(chosenVariants, 'mostEffectiveCheckoutStep');
    return (
      <footer className={style.footerWrap}>
        <hr className={style.mainHr}/>
        {!(!!chosenVariant.index && location.pathname.split('/')[2] === 'checkout') &&
        <section className={style.top}>
          <section className={classNames(style.topContent, {
            [style.isTiendas]: isTiendas,
          })}>
            <article style={{ gridArea: 'qempo' }}>
              <button className={style.openBtn}
                      onClick={this.handleClick.bind(this)}
                      name="infoOpen"
                      type="button">
                <FormattedMessage id="footer.qempo">{
                  txt => (<h3>{txt}</h3>)
                }</FormattedMessage>
                <i className={infoOpen ? icons.iconChevronUpLight : icons.iconChevronDownLight}/>
              </button>
              <ul className={classNames({ [style.open]: infoOpen })}>
                <li>
                  <FormattedMessage id="footer.about">{
                    txt => <Link title={txt} to="/about-us">{txt}</Link>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.blog">{
                    txt => <a href="/blog/" target="_blank">{txt}</a>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.complaintsBook">{
                    txt => <a href="mailto:hola@qempo.com?Subject=Hola%20Qempo,%20necesito%20ayuda.">
                      {/*<i className={icons.iconMailLight}/>*/}
                      {txt}</a>
                  }</FormattedMessage>
                </li>
              </ul>
            </article>
            {!isTiendas &&
            <article style={{ gridArea: 'buy' }}>
              <button className={style.openBtn}
                      onClick={this.handleClick.bind(this)}
                      name="resOpen"
                      type="button">
                <FormattedMessage id="footer.buy">{
                  txt => (<h3>{txt}</h3>)
                }</FormattedMessage>
                <i className={resOpen ? icons.iconChevronUpLight : icons.iconChevronDownLight}/>
              </button>
              <ul className={classNames({ [style.open]: resOpen })}>
                {/*<li>
                  <FormattedMessage id="footer.bestDeals">{
                    txt => <Link title={txt} to="/best-deals">{txt}</Link>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.stores">{
                    txt => <Link title={txt} to="/stores">{txt}</Link>
                  }</FormattedMessage>
                </li>*/}
                <li>
                  <FormattedMessage id="footer.orders">{
                    txt => <Link title={txt} to="/orders/active">{txt}</Link>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.earnMoney.buy">{
                    txt => <a target="_blank"
                              href="https://help.qempo.com/article/753ns7hwy5-c-mo-gano-dinero-invitando-a-mis-amigos">{txt}</a>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.importByCargo">{
                    txt => <Link title={txt} to="/cargo">{txt}</Link>
                  }</FormattedMessage>
                </li>
              </ul>
            </article>}
            {!isTiendas &&
            <article style={{ gridArea: 'logistics' }}>
              <button className={style.openBtn}
                      onClick={this.handleClick.bind(this)}
                      name="serOpen"
                      type="button">
                <FormattedMessage id="footer.logistics">{
                  txt => (<h3>{txt}</h3>)
                }</FormattedMessage>
                <i className={serOpen ? icons.iconChevronUpLight : icons.iconChevronDownLight}/>
              </button>
              <ul className={classNames({ [style.open]: serOpen })}>
                {/*<li>
                  <FormattedMessage id="footer.earnMoney.travel">{
                    txt => <Link title={txt} to="/new-flight">{txt}</Link>
                  }</FormattedMessage>
                </li>*/}
                {/*<li>
                  <FormattedMessage id="footer.bonifications">{
                    txt => <a target="_blank"
                              href="https://help.qempo.com/article/7d9m9iufqp-c-mo-funcionan-las-bonificaciones-para-viajeros">{txt}</a>
                  }</FormattedMessage>
                </li>*/}
                <li>
                  <FormattedMessage id="footer.couriers">{
                    txt => <a target="_blank"
                              href="https://help.qempo.com/article/3j6wdevik6-soy-una-empresa-de-courier-o-carga">{txt}</a>
                  }</FormattedMessage>
                </li>
              </ul>
            </article>}
            <article style={{ gridArea: 'help' }}>
              <button className={style.openBtn}
                      onClick={this.handleClick.bind(this)}
                      name="conOpen"
                      type="button">
                <FormattedMessage id="footer.help">{
                  txt => (<h3>{txt}</h3>)
                }</FormattedMessage>
                <i className={conOpen ? icons.iconChevronUpLight : icons.iconChevronDownLight}/>
              </button>
              <ul className={classNames({ [style.open]: conOpen })}>
                <li>
                  <FormattedMessage id="footer.helpCenter">{
                    txt => <a title={txt}
                              href="https://help.qempo.com/"
                              target="_blank">{txt}</a>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.termsAndConditions">{
                    txt => <Link title={txt} to="/terms-of-service">{txt}</Link>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.privacyPolicy">{
                    txt => <Link title={txt} to="/privacy-policy">{txt}</Link>
                  }</FormattedMessage>
                </li>
                <li>
                  <FormattedMessage id="footer.helpWithOrder">{
                    txt => <Link title={txt} to="/help-ticket">{txt}</Link>
                  }</FormattedMessage>
                </li>
              </ul>
            </article>
          </section>
          <section className={style.socialElementWrap}>
            <article className={style.socialElements}>
              <a href="https://www.facebook.com/Qempo" target="_blank">
                <i className={icons.symbolFacebook}/>
              </a>
              <a href="https://www.instagram.com/qempo" target="_blank">
                <i className={icons.symbolInstagram}/>
              </a>
              <a href="https://twitter.com/Qempito" target="_blank">
                <i className={icons.symbolTwitter}/>
              </a>
            </article>
          </section>
        </section>}
        <section className={style.bottom}>
          {isBrowser &&
          <section className={style.bottomContent}>
            <section className={style.enterprise}>
              <img className={style.greyLogo}
                   src={greyLogo}
                   alt="Qempo"/>
              <span>© 2025 Qempo LLC. All rights reserved</span>
            </section>
            {/*<section className={style.socialElementWrap}>
              <article className={style.socialElements}>
                <a href="https://www.facebook.com/Qempo" target="_blank">
                  <i className={icons.symbolFacebook}/>
                </a>
                <a href="https://www.instagram.com/qempo" target="_blank">
                  <i className={icons.symbolInstagram}/>
                </a>
                <a href="https://twitter.com/Qempito" target="_blank">
                  <i className={icons.symbolTwitter}/>
                </a>
              </article>
            </section>*/}
            <section className={style.localeWrap}>
              <article className={style.language}>
                <i className={classNames(style.iconChat, icons.symbolChat)}/>
                <select name="locale"
                        value={localeState.locale}
                        onChange={this.handleChangeLocale}>
                  <FormattedMessage id="footer.spanish" defaultMessage="Español">
                    {txt => (
                      <option value="es">{txt}</option>
                    )}
                  </FormattedMessage>
                  <FormattedMessage id="footer.english" defaultMessage="Inglés">
                    {txt => (
                      <option value="en">{txt}</option>
                    )}
                  </FormattedMessage>
                </select>
              </article>
              <article className={style.country}>
                {/*<img src={countryIcon}
                     alt={localeState.domainCountry}/>*/}
                <select name="country"
                        value={localeState.domainCountry || 'US'}
                        onChange={this.handleChangeCountry}>
                  {countryOptions}
                </select>
              </article>
            </section>
          </section>}
        </section>
      </footer>
    );
  }
}

Footer.propTypes = {
  localeState: PropTypes.object,
  authenticated: PropTypes.bool,
  user: PropTypes.object,
  changeLocale: PropTypes.func.isRequired,
  editProfile: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  localValues: PropTypes.object.isRequired,
  chosenVariants: PropTypes.object,
};

Footer.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/footer/components/Footer.jsx